<template>
  <div>
    <b-row>
      <b-col lg="6" class="px-1">
        <div
          v-for="module in modulesPrepared.slice(0, 4)"
          :key="module"
          :class="getClass(module)"
        >
          <img
            v-if="checked(module)"
            :src="checkIcon"
            alt="check"
            class="mb-1 checked-module"
          />
          <img v-else :src="xIcon" alt="" />
          <label class="mb-0 addscontent">{{ label(module) }}</label>
        </div>
      </b-col>
      <b-col lg="6" class="px-1" v-if="modulesPrepared.length > 4">
        <div
          v-for="module in modulesPrepared.slice(-(modulesPrepared.length - 4))"
          :key="module"
          :class="getClass(module)"
        >
          <img
            v-if="checked(module)"
            :src="checkIcon"
            alt="check"
            class="mb-1"
          />
          <img v-else :src="xIcon" alt="" />
          <label class="mb-0 addscontent">{{ label(module) }}</label>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { modules, m_sam, m_skp_B, m_skp_F } from '../config/modules';

export default {
  name: 'Modules',
  props: {
    checkedAdds: {},
    checkedModules: {},
    isAccountant: {},
    checkIcon: {},
    xIcon: {},
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
    }),
    modulesPrepared() {
      let modules =
        this.program === 'sam' ? m_sam : this.isAccountant ? m_skp_B : m_skp_F;

      this.checkedModules.forEach(function (checked) {
        if (modules.includes(checked)) {
          modules = modules.filter((item) => item !== checked);
          modules.unshift(checked);
        }
      });
      return modules;
    },
  },
  methods: {
    label(value) {
      return modules[value].label;
    },
    checked(value) {
      return this.checkedModules.includes(value);
    },
    getClass(add) {
      if (!this.checked(add)) {
        return 'text-secondary px-1 m-1';
      } else {
        return 'border px-1 m-1';
      }
    },
  },
};
</script>

<style scoped></style>
